import { EnvironmentUrls, Endpoints } from 'Roblox';
import { httpService } from 'core-utilities';

const logoutUrl = `${EnvironmentUrls.authApi}/v2/logout`;

const logout = async (): Promise<unknown> => {
  const urlConfig: { url: string; withCredentials: boolean } = {
    url: logoutUrl,
    withCredentials: true
  };
  return httpService.post(urlConfig).then(() => {
    const url = Endpoints.getAbsoluteUrl('/');
    window.location.href = url;
  });
};

export default logout;
